export const NR_AGENT_ID = 'whiteLabelPreferenceFragment';

const NEW_RELIC_LICENSE_KEY = process.env.NR_LICENSE_KEY;
const NEW_RELIC_APP_ID = process.env.NR_APP_ID;

export const NEWRELIC_AGENT_CONFIG = {
  init: {
    privacy: { cookies_enabled: true },
  }, // NREUM.init
  info: {
    beacon: 'bam.nr-data.net',
    errorBeacon: 'bam.nr-data.net',
    licenseKey: `${NEW_RELIC_LICENSE_KEY}`,
    applicationID: `${NEW_RELIC_APP_ID}`,
    sa: 1,
  }, // NREUM.info
  loader_config: {
    accountID: '2429158',
    trustKey: '1106546',
    agentID: `${NEW_RELIC_APP_ID}`,
    licenseKey: `${NEW_RELIC_LICENSE_KEY}`,
    applicationID: `${NEW_RELIC_APP_ID}`,
  }, // NREUM.loader_config
};

export const FULFILLMENT_PREFERENCE_SAVE_ACTION_NAME =
  'successfully-saved-fulfillment-preference';
export const FULFILLMENT_PREFERENCE_SAVE_ERROR_NAME =
  'shopper-fulfillment-preferences-patch';
export const FULFILLMENT_PREFERENCE_FETCH_ERROR_NAME =
  'shopper-fulfillment-preferences-fetch';

export const REACT_QUERY_RETRIES_EXHAUSTED_ERROR_NAME =
  'react-query-retry-exceeds-threshold';
